import { ChooseTemplateModal } from "@/components/ChooseTemplateModal";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";

import { Link } from "lucide-react";
import { observer } from "mobx-react-lite";
import { useSnippetDialog } from "./snippet-store";

const SnippetDialog = () => {
  const dialog = useSnippetDialog();

  const handleNavigateAway = () => {
    dialog.closeDialog();
  };

  const handleOpenChange = (open: boolean) => {
    if (!open) {
      dialog.closeDialog();
    }
  };

  return (
    <Dialog open={dialog.isOpen} onOpenChange={handleOpenChange}>
      <DialogContent className="sm:max-w-[425px]">
        <DialogHeader>
          <DialogTitle>Link a snippet</DialogTitle>
          <DialogDescription className="mt-1 text-sm text-gray-500">
            Use a prompt template as a reference snippet in your current
            template, compiled at runtime.
            <a
              href="https://docs.promptlayer.com/features/prompt-registry/snippets"
              target="_blank"
              rel="noreferrer"
              className="text-sm text-blue-500 hover:text-blue-400"
            >
              {" "}
              Learn more. <Link className="inline h-4 w-4 pl-1" />
            </a>
          </DialogDescription>
        </DialogHeader>
        <ChooseTemplateModal
          navigateAway={handleNavigateAway}
          navigateBack={() => dialog.cancel()}
          submitText="Add"
          cancelText="Cancel"
          editable={true}
          configuration={dialog.configuration}
          setConfiguration={(config) => {
            if (typeof config === "function") {
              dialog.setConfiguration({ ...config(dialog.configuration) });
            } else {
              dialog.setConfiguration(config);
            }
          }}
          showSnippetWarning={true}
          sourceTemplateId={0}
          isSnippet={true}
        />
      </DialogContent>
    </Dialog>
  );
};

export default observer(SnippetDialog);
